import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import PartnerLogo from '../../components/Donation/PartnerLogo';

const Container = styled.div`
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    margin-bottom: 12px;
`;

const LogoContainer = styled.div``;

const MobileDetailsHeader = props => (
    <Container>
        <LogoContainer>
            <PartnerLogo
                isSmall
                logoUrl={props.partnerLogo}
                marginBottom={'0'}
                onClick={props.onPartnerClick}
            />
        </LogoContainer>
    </Container>
);

MobileDetailsHeader.propTypes = {
    partnerLogo: PropTypes.string,
    onPartnerClick: PropTypes.func
};

export default MobileDetailsHeader;
